const { first } = require("lodash");
import firebase from "firebase/app";
import "firebase/firebase-messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBgX1GHGuSacCj0kFVEyBSkutF9MJfqD9s",
    authDomain: "sportske-b3ae2.firebaseapp.com",
    projectId: "sportske-b3ae2",
    storageBucket: "sportske-b3ae2.appspot.com",
    messagingSenderId: "902167170027",
    appId: "1:902167170027:web:910d7a3688b76940ea67ae",
};

var resizeTimer;

jQuery(function ($) {
    $(".icon-search--rounded").on("click", function (event) {
        let searchWidth = $(".navigation__search-desktop").css("width");
        if (searchWidth === "0px") {
            $(".navigation__search-desktop").animate({
                width: "200px",
            });
        } else {
            $(".navigation__search-desktop").animate({
                width: "0",
            });
        }
    });

    firebase.initializeApp(firebaseConfig);
    if (firebase.messaging.isSupported()) {
        const firebaseMessaging = firebase.messaging();

        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("/firebase-messaging-sw.js")
                .then((reg) => {
                    console.log(
                        `FCM: Service Worker Registration (Scope: ${reg.scope})`
                    );
                })
                .catch((error) => {
                    console.error(`FCM: Service Worker Error (${error})`);
                });
        } else {
            console.warn("Service Worker not available");
        }

        firebaseMessaging
            .getToken({
                vapidKey:
                    "BCdn_2oZ6InEG9baRKHnk9h25pjriSPXrbQRiyQQnLmdegiHfuUELRg7rmUSoFOUaQoBb5sCihYF8al5AWgSnzE",
            })
            .then((currentToken) => {
                if (currentToken) {
                    Notification.requestPermission()
                        .then(() => {
                            $.get(
                                `public-api/notifications/f/assign_token/${currentToken}`,
                                (response) => {},
                                "json"
                            );
                        })
                        .catch((err) => {
                            console.log("Permission denied.", err);
                        });
                }
            })
            .catch((err) => {
                console.log("An error occurred while retrieving token. ", err);
            });
        const messaging = firebase.messaging();
        messaging.onMessage((payload) => {
            console.log("Message received. ", payload);
        });
    }

    //open menu on burger

    $(".header-mobil__bars").on("click", function (event) {
        openMobilMenu(this);
        event.stopPropagation();
        event.preventDefault();
    });

    function openMobilMenu(element) {
        $(".navigation-wrapper").addClass("show--mobile-menu");
    }

    function closeMobilMenuOnResize() {
        if (
            $(window).width() >= 990 &&
            $(".navigation-wrapper").hasClass("show--mobile-menu")
        ) {
            $(".navigation-wrapper").removeClass("show--mobile-menu");
        }
    }

    // arrows transform

    $(".navigation .arrow").on("click", function (event) {
        $(event.target).toggleClass("down");
        $(event.target).toggleClass("up");
        $(event.target)
            .parent()
            .parent()
            .find("ul")
            .first()
            .toggleClass("show");
        event.stopPropagation();
    });

    $("body").on("click", function (event) {
        if ($(".navigation-wrapper").hasClass("show--mobile-menu")) {
            $(".navigation-wrapper").removeClass("show--mobile-menu");
            event.stopPropagation();
        }
    });

    //open search desktop

    //open user-panel tabs

    $(".navigation--user-panel .arrow").on("click", function (event) {
        event.preventDefault();
        $(event.target).toggleClass("down");
        $(event.target).toggleClass("up");
        $(event.target)
            .parent()
            .parent()
            .parent()
            .find(".user-panel-wrapper")
            .first()
            .toggleClass("show--user-panel");
        event.stopPropagation();
    });

    $(".navigation__main--user-panel").on("click", function (event) {
        event.preventDefault();
        $(".navigation__main--user-panel").removeClass(
            "user-panel--highlighted"
        );
        $(this).addClass("user-panel--highlighted");
        $(".user-panel-wrapper").removeClass("show--user-panel");
        $(event.target)
            .parent()
            .parent()
            .find(".user-panel-wrapper")
            .first()
            .addClass("show--user-panel");
        event.stopPropagation();
    });

    function userPanelClickOnFirstTab() {
        if ($(window).width() >= 990) {
            $(".navigation__main--user-panel").first().trigger("click");
            $(".navigation__main--user-panel").removeClass(
                "user-panel--highlighted"
            );
            $(".navigation__main--user-panel")
                .first()
                .addClass("user-panel--highlighted");
            if ($(".arrow--user").is(":visible")) {
                $(".navigation__main--user-panel")
                    .first()
                    .find(".arrow")
                    .removeClass("down")
                    .addClass("up");
            }
        }
    }

    function closeUserPanelTabsOnResize() {
        if ($(window).width() < 990) {
            $(".user-panel-wrapper").removeClass("show--user-panel");
            $(".navigation__main--user-panel").removeClass(
                "user-panel--highlighted"
            );
            $(".navigation__main--user-panel")
                .find(".arrow")
                .removeClass("up")
                .addClass("down");
        }
    }

    //carousel

    var owl = $(".owl-carousel").owlCarousel({
        loop: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1000: {
                items: 1,
            },
        },
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        dots: false,
        nav: false,
        pagination: false,
    });

    owl.on("changed.owl.carousel", function (e) {
        var index =
            1 +
                ((e.property.value - Math.ceil(e.item.count / 2)) %
                    e.item.count) ||
            0 ||
            1;
        highlightSlide(index - 1);
    });

    function highlightSlide(slideID) {
        let smallNewsArray = $("#owl-carousel-small-news").children();
        $(smallNewsArray).removeClass("highlighted-slide");
        let selectedSlide = smallNewsArray[slideID];
        $(selectedSlide).addClass("highlighted-slide");
    }

    //resize

    $(window).on("resize", function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
            closeMobilMenuOnResize();
            closeUserPanelTabsOnResize();
            userPanelClickOnFirstTab();
        }, 100);
    });

    userPanelClickOnFirstTab();

    $(".sumoselect").SumoSelect({ search: true, searchText: "Pretraga." });

    $(".date--future").on("click", function (event) {
        event.preventDefault();
    });

    $(".small-news-zebra__header__tab").on("click", function (event) {
        event.preventDefault();
        $(".small-news-zebra__header__tab").removeClass("tab-highlighted");
        $(this).addClass("tab-highlighted");
        $(".small-news-zebra__content").removeClass("show--news-panel");
        let className = $(this).find("a").data("id");
        console.log(className);
        $("." + className).addClass("show--news-panel");
        event.stopPropagation();
    });

    $(".comment-reply").on("click", function (event) {
        event.preventDefault();

        let html = $("#comments__form");
        // let loggedIn = html.find("input[name='logged_in']").val();
        // if (loggedIn === undefined) {
        //     return alert(
        //         "Morate da se prijavite da bi ste mogli da ostavite komentar."
        //     );
        // }

        if ($(this).data("status") === "open") {
            let parentCommentId = $(this).parent().data("id");
            html.find("input[name='parent_id']").val(parentCommentId);
            $(this).parent().find(".comments__reply__box").html(html);
            $(".reply-button").text("Odgovori");
            $(".comment-reply").data("status", "open");
            $(this).find(".reply-button").text("Zatvori");
            $(this).data("status", "close");
            $(".comments__form-wrapper").find("form").remove();
        } else {
            $(this).find(".reply-button").text("Odgovori");
            $(this).data("status", "open");
            $(this).parent().find(".comments__reply__box").html("");
            html.find("input[name='parent_id']").val(null);
            $(".comments__form-wrapper").html(html);
        }
        event.stopPropagation();
    });

    let formRequest;
    $("#comments__form").on("submit", function (event) {
        event.preventDefault();
        let guestNameValue = $(this).find("input[name='guest_name']");
        let commentValue = $(this).find("textarea[name='comment']");

        if (formRequest) {
            formRequest.abort();
        }

        let parentId = $(this).find("#parent_id").val();
        const token = $(this).find('[name="_token"]').val();
        let actionUrl = $(this).attr("action");

        formRequest = $.ajax({
            url: actionUrl + "/api",
            type: "post",
            data: {
                _token: token,
                parent_id: parentId,
                guest_name: guestNameValue.val(),
                comment: commentValue.val(),
            },
        });
        formRequest.done(function (response) {
            if (response.success === true) {
                guestNameValue.val("");
                commentValue.val("");
                alert(
                    "Komentar je uspešno upisan i čeka odobrenje administratora."
                );
            }
        });

        formRequest.fail(function (jqXHR, textStatus, errorThrown) {
            console.error(
                "The following error occurred: " + textStatus,
                errorThrown
            );
            if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.guest_name) {
                alert(jqXHR.responseJSON.errors.guest_name[0]);
            } else {
                alert("Došlo je do greške prilikom upisa komentara.");
            }
        });
    });

    let request;
    $(".comment-action").on("click", function (event) {
        event.preventDefault();

        let loggedIn = $("#logged_in").val();
        if (!loggedIn) {
            return alert(
                "Morate da se prijavite da bi ste mogli da ostavite utisak."
            );
        }
        if (request) {
            request.abort();
        }

        let id = $(this).parent().data("id");
        let action = $(this).data("action");
        let token = $(this).data("csrf");

        request = $.ajax({
            url: "/comment-action",
            type: "post",
            data: {
                _token: token,
                commentId: id,
                action: action,
            },
        });
        let counter = $(this).find(".icons-padding");
        request.done(function (response) {
            if (response.success === true) {
                counter.text(response.count);
            }
        });

        request.fail(function (jqXHR, textStatus, errorThrown) {
            console.error(
                "The following error occurred: " + textStatus,
                errorThrown
            );
        });
    });
});
